import siteActions from "../services/siteActions";
import React, { useEffect, useState } from "react";
import {
  Paper,
  TextField,
  Typography,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  Table,
  TableBody,
  Button,
  IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const ProviderSiteListSubcomponent = ({ name, providerSites, handleSave }) => {
  const [sites, setSites] = useState(providerSites || []);
  const [showKeys, setShowKeys] = useState(false);
  const [showSecret, setShowSecret] = useState(false);

  const handleChange = (event, index, field) => {
    const newSites = [...sites];
    newSites[index][field] = event.target.value;
    setSites(newSites);
  };

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{name}</TableCell>
            <TableCell onClick={() => setShowKeys(!showKeys)}>
              <IconButton size="small" title="Cozify Key">
                {showKeys ? <VisibilityOff /> : <Visibility />}
                Cozify Key
              </IconButton>
            </TableCell>
            <TableCell onClick={() => setShowSecret(!showSecret)}>
              <IconButton size="small" title="Cozify Secret">
                {showSecret ? <VisibilityOff /> : <Visibility />}
                Cozify Secret
              </IconButton>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sites.map((site, siteIndex) => (
            <TableRow key={siteIndex}>
              <TableCell>
                <Typography>{site.name}</Typography>
              </TableCell>
              <TableCell>
                <TextField
                  fullWidth
                  label="cozifyKey"
                  type={showKeys ? "text" : "password"}
                  value={site.cozifyKey}
                  onChange={(event) =>
                    handleChange(event, siteIndex, "cozifyKey")
                  }
                />
              </TableCell>
              <TableCell>
                <TextField
                  fullWidth
                  label="cozifySecret"
                  type={showSecret ? "text" : "password"}
                  value={site.cozifySecret}
                  onChange={(event) =>
                    handleChange(event, siteIndex, "cozifySecret")
                  }
                />
              </TableCell>
              <TableCell>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    const body = {
                      cozifyKey: site.cozifyKey,
                      cozifySecret: site.cozifySecret,
                    };
                    handleSave(site.id, body);
                  }}
                >
                  Save
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const ServiceSiteComponent = ({ serverUuid }) => {
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    fetchSites(serverUuid);
  }, []);

  const fetchSites = async (serverId) => {
    const result = await siteActions.getSites(serverId);

    if (result?.success) {
      setProviders(result.data);
    }
  };

  const updateSite = async (siteId, body) => {
    const { success } = await siteActions.updateSite(serverUuid, siteId, body);

    if (success) {
      fetchSites(serverUuid);
    }
  };

  return (
    <Paper style={{ backgroundColor: "#f9fafb" }}>
      {providers &&
        providers.map((provider, i) => (
          <ProviderSiteListSubcomponent
            key={i}
            name={provider?.name}
            providerSites={provider?.sites}
            handleSave={updateSite}
          />
        ))}
    </Paper>
  );
};

export default ServiceSiteComponent;
